import React, { useEffect, useState } from "react";
import { saveAs } from "file-saver";
import { PDFDocument } from "pdf-lib";
import Form from "../Components/Form";
import { useLocation, useNavigate } from "react-router-dom";
import { auth, db } from "../firebase.config";
import { storage } from "../firebase.config";
import {
  getDownloadURL,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import { v4 } from "uuid";
import { collection, addDoc, updateDoc, doc } from "firebase/firestore";
import { useSelector } from "react-redux";
import { extractSlugPart, unSlugify } from "../utils/helperFunctions";

const PartnerExhibit = ({
  pdfExhibit,
  setPdfExhibit,
  currentDate,
  imgExhibit,
  setImgExhibit,
  setReviewExhibitID,
}) => {
  const [exhibitData, setExhibitData] = useState({});
  const navigate = useNavigate();
  const newDate = new Date();
  const timeStamp = newDate.toJSON().replaceAll(":", "-").replaceAll(".", "-");
  const location = useLocation();
  const match = location.pathname.match(/\/([^\/]+)\//);
  const sluggedCompany = match ? match[1] : null;
  const companyName = unSlugify(sluggedCompany);
  const [imageUpload, setImageUPload] = useState(null);
  const [fileUploads, setFileUploads] = useState([]);
  const [fileUrls, setFileUrls] = useState([]);
  const imagePath = `${sluggedCompany}/images/${imageUpload?.name + v4()}`;
  const [progress, setProgress] = useState(0);
  const uploadImage = () => {};

  useEffect(() => {
    console.log(location.pathname);
  }, []);

  const addExhibit = async (exhibit) => {
    try {
      const docRef = await addDoc(collection(db, "exhibits"), exhibit);
      console.log("Document written with ID: ", docRef.id);

      // Update document with ID
      await updateDoc(doc(db, "exhibits", docRef.id), {
        id: docRef.id,
        fileUrls: exhibit.fileUrls,
      });

      setReviewExhibitID(docRef.id);
      alert(
        `Your Exhibit, along with any attachments, has been submitted to ${unSlugify(
          extractSlugPart(location.pathname)
        )}`
      );
      navigate(0);
      return docRef.id;
    } catch (e) {
      console.error("Error adding document", e);
    }
  };

  async function fillForm(exhibitDataForm) {
    let myStatus = "Partner Started";
    const formUrl =
      "https://www.mlinc.collinicoding.com/ComplyOfficeExhibit.pdf";
    const formPdfBytes = await fetch(formUrl).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(formPdfBytes);
    const form = pdfDoc.getForm();
    const serviceProviderLessor = form.getTextField("Service Provider Lessor");
    const commonName = form.getTextField("Common/Branded Name");
    const address = form.getTextField("Location Address");
    const city = form.getTextField("City");
    const state = form.getTextField("State");
    const zipCode = form.getTextField("Zip Code");
    const description = form.getTextField("Additional Description");
    const startDate = form.getTextField("Expected Start Date");
    const sqftLeased = form.getTextField("Square Feet Leased");
    const expectedTerm = form.getTextField("Expected Term of Lease");
    const numberOfDesks = form.getTextField("Number of Desks/Workstations");
    const companyName = form.getTextField("Company Lessee");
    const signature = form.getField("Signature");
    const signDate = form.getField("Date Signed");

    const office = form.getCheckBox("Office");
    const industrial = form.getCheckBox("Industrial/Warehouse");
    const retail = form.getCheckBox("Retail");
    const mixed = form.getCheckBox("Mixed/Other");
    const privateOffice = form.getCheckBox("Private Office");
    const cubicle = form.getCheckBox("Cubicle");
    const interior = form.getCheckBox("Interior");
    const exterior = form.getCheckBox("Exterior/Window");
    const cam = form.getCheckBox("Common area maintenance");
    const furnishings = form.getCheckBox("Furniture and furnishings");
    const janitorial = form.getCheckBox("Janitorial");
    const parking = form.getCheckBox("Parking");
    const insurace = form.getCheckBox("Property insurance and taxes");
    const electirc = form.getCheckBox("Electricity");
    const gas = form.getCheckBox("Gas/Oil/Propane");
    const water = form.getCheckBox("Water");
    const phone = form.getCheckBox("Phone");
    const internet = form.getCheckBox("Internet/WiFi");
    const conference = form.getCheckBox("Furnished conference room(s) use");
    const kitchen = form.getCheckBox("Kitchen");
    const copyFax = form.getCheckBox("Copy/fax/printer/scanner use");
    const receptionist = form.getCheckBox("Receptionist/Answering");

    // I need to add the ability to add attachments

    let exhibit = {
      serviceProvider: exhibitDataForm.serviceProvider,
      commonName: exhibitDataForm.commonName,
      locationAddress: exhibitDataForm.locationAddress,
      city: exhibitDataForm.city,
      state: exhibitDataForm.state,
      zipcode: exhibitDataForm.zipcode,
      sqftLeased: exhibitDataForm.sqftLeased,
      term: exhibitDataForm.term,
      desks: exhibitDataForm.desks,
      propertyType: exhibitDataForm.propertyType,
      spaceType: exhibitDataForm.spaceType,
      settingType: exhibitDataForm.settingType,
      facility: exhibitDataForm.facility,
      utility: exhibitDataForm.utility,
      amenity: exhibitDataForm.amenity,
      description: exhibitDataForm.description,
      startDate: exhibitDataForm.startDate,
      companyName: unSlugify(extractSlugPart(location.pathname)),
      signDate: currentDate,
      createdDate: currentDate,
      status: myStatus,
    };
    //this is where the form information will be taken and used to fill in the pdf form

    serviceProviderLessor.setText(exhibitDataForm.serviceProvider);
    commonName.setText(exhibitDataForm.commonName);
    address.setText(exhibitDataForm.locationAddress);
    city.setText(exhibitDataForm.city);
    state.setText(exhibitDataForm.state);
    zipCode.setText(exhibitDataForm.zipcode.toString());
    sqftLeased.setText(exhibitDataForm.sqftLeased.toString());
    description.setText(exhibitDataForm.description);
    startDate.setText(exhibitDataForm.startDate);
    expectedTerm.setText(exhibitDataForm.term);
    numberOfDesks.setText(exhibitDataForm.desks.toString());
    companyName.setText(exhibit.companyName);
    signDate.setText(currentDate);

    switch (exhibitDataForm.propertyType) {
      case "Office":
        office.check();
        break;
      case "Industrial/Warehouse":
        industrial.check();
        break;
      case "Retail":
        retail.check();
        break;
      case "Mixed/Other":
        mixed.check();
        break;
      default:
        break;
    }

    switch (exhibitDataForm.spaceType) {
      case "Private office":
        privateOffice.check();
        break;
      case "cubicle":
        cubicle.check();
        break;
      default:
        break;
    }

    switch (exhibitDataForm.settingType) {
      case "Interior":
        interior.check();
        break;
      case "Window":
        exterior.check();
        break;
      default:
        break;
    }

    !!exhibitDataForm.facility &&
      exhibitDataForm.facility.forEach((item) => {
        switch (item) {
          case "cam":
            cam.check();
            break;
          case "furnished":
            furnishings.check();
            break;
          case "janitorial":
            janitorial.check();
            break;
          case "parking":
            parking.check();
            break;
          case "tax":
            insurace.check();
            break;
          default:
            break;
        }
      });

    !!exhibitDataForm.utility &&
      exhibitDataForm.utility.forEach((item) => {
        switch (item) {
          case "electricity":
            electirc.check();
            break;
          case "gas":
            gas.check();
            break;
          case "water":
            water.check();
            break;
          case "phone":
            phone.check();
            break;
          case "internet":
            internet.check();
            break;
          default:
            break;
        }
      });

    !!exhibitDataForm.amenity &&
      exhibitDataForm.amenity.forEach((item) => {
        switch (item) {
          case "meeting":
            conference.check();
            break;
          case "kitchen":
            kitchen.check();
            break;
          case "copy":
            copyFax.check();
            break;
          case "receptionist":
            receptionist.check();
            break;
          default:
            break;
        }
      });

    const pdfBytes = await pdfDoc.save();
    const newFile = new File([pdfBytes], "myTest.pdf", {
      type: "application/pdf",
    });

    // Create a reference for the PDF file in Firebase Storage
    const pdfRef = ref(
      storage,
      `${sluggedCompany}/pdfs/complyOfficeExhibit${timeStamp}`
    );

    // Upload the PDF
    const pdfUploadTask = uploadBytesResumable(pdfRef, newFile);

    // Handle PDF upload progress and completion
    pdfUploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        console.log(`PDF upload is ${progress}% done`);
      },
      (error) => {
        console.error("PDF upload error:", error);
      },
      async () => {
        console.log("PDF upload complete, fetching URL...");
        const pdfURL = await getDownloadURL(pdfUploadTask.snapshot.ref);
        console.log(`PDF is now available at ${pdfURL}`);

        exhibit.pdfURL = pdfURL; // Store the URL in your exhibit object

        // Prepare for other file uploads
        const promises = [];
        const uploadedUrls = []; // Array to hold the uploaded URLs

        fileUploads.forEach((file, index) => {
          const fileName = file.name || file.label || `file_${index}`;
          const storageRef = ref(
            storage,
            `/${sluggedCompany}/uploads/${fileName + v4()}`
          );

          // Create a resumable upload task for each file
          const uploadTask = uploadBytesResumable(storageRef, file);

          // Add progress listener
          uploadTask.on(
            "state_changed",
            (snapshot) => {
              const progress = Math.round(
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              );
              console.log(`Upload #${index + 1} is ${progress}% done`);
            },
            (error) => {
              console.error(`Upload #${index + 1} error:`, error);
            },
            async () => {
              console.log(`Upload #${index + 1} is complete, fetching URL...`);
              const url = await getDownloadURL(uploadTask.snapshot.ref);
              console.log(`Upload #${index + 1} is now available at ${url}.`);
              uploadedUrls.push(url); // Add the URL to the array
            }
          );

          // Wait for the upload task to complete
          promises.push(uploadTask);
        });

        // Wait for all uploads to complete
        Promise.all(promises)
          .then(() => {
            // Ensure that fileUrls is updated correctly
            exhibit.fileUrls = uploadedUrls;

            // Now add the exhibit with the updated URLs
            addExhibit({ ...exhibit, fileUrls: exhibit.fileUrls }, myStatus);
          })
          .catch((err) => console.error("Error during file uploads:", err));
      }
    );
  }

  // async function fillForm(exhibitDataForm) {
  //   const formUrl =
  //     "https://www.mlinc.collinicoding.com/ComplyOfficeExhibit.pdf";
  //   const formPdfBytes = await fetch(formUrl).then((res) => res.arrayBuffer());
  //   const pdfDoc = await PDFDocument.load(formPdfBytes);
  //   const form = pdfDoc.getForm();
  //   const serviceProviderLessor = form.getTextField("Service Provider Lessor");
  //   const commonName = form.getTextField("Common/Branded Name");
  //   const address = form.getTextField("Location Address");
  //   const city = form.getTextField("City");
  //   const state = form.getTextField("State");
  //   const zipCode = form.getTextField("Zip Code");
  //   const description = form.getTextField("Additional Description");
  //   const startDate = form.getTextField("Expected Start Date");
  //   const sqftLeased = form.getTextField("Square Feet Leased");
  //   const expectedTerm = form.getTextField("Expected Term of Lease");
  //   const numberOfDesks = form.getTextField("Number of Desks/Workstations");
  //   const companyNameForm = form.getTextField("Company Lessee");

  //   const office = form.getCheckBox("Office");
  //   const industrial = form.getCheckBox("Industrial/Warehouse");
  //   const retail = form.getCheckBox("Retail");
  //   const mixed = form.getCheckBox("Mixed/Other");
  //   const privateOffice = form.getCheckBox("Private Office");
  //   const cubicle = form.getCheckBox("Cubicle");
  //   const interior = form.getCheckBox("Interior");
  //   const exterior = form.getCheckBox("Exterior/Window");
  //   const cam = form.getCheckBox("Common area maintenance");
  //   const furnishings = form.getCheckBox("Furniture and furnishings");
  //   const janitorial = form.getCheckBox("Janitorial");
  //   const parking = form.getCheckBox("Parking");
  //   const insurace = form.getCheckBox("Property insurance and taxes");
  //   const electirc = form.getCheckBox("Electricity");
  //   const gas = form.getCheckBox("Gas/Oil/Propane");
  //   const water = form.getCheckBox("Water");
  //   const phone = form.getCheckBox("Phone");
  //   const internet = form.getCheckBox("Internet/WiFi");
  //   const conference = form.getCheckBox("Furnished conference room(s) use");
  //   const kitchen = form.getCheckBox("Kitchen");
  //   const copyFax = form.getCheckBox("Copy/fax/printer/scanner use");
  //   const receptionist = form.getCheckBox("Receptionist/Answering");

  //   // I need to add the ability to add attachments

  //   let exhibit = {
  //     serviceProvider: exhibitDataForm.serviceProvider,
  //     commonName: exhibitDataForm.commonName,
  //     locationAddress: exhibitDataForm.locationAddress,
  //     city: exhibitDataForm.city,
  //     state: exhibitDataForm.state,
  //     zipcode: exhibitDataForm.zipcode,
  //     sqftLeased: exhibitDataForm.sqftLeased,
  //     term: exhibitDataForm.term,
  //     desks: exhibitDataForm.desks,
  //     propertyType: exhibitDataForm.propertyType,
  //     spaceType: exhibitDataForm.spaceType,
  //     settingType: exhibitDataForm.settingType,
  //     facility: exhibitDataForm.facility,
  //     utility: exhibitDataForm.utility,
  //     amenity: exhibitDataForm.amenity,
  //     description: exhibitDataForm.description,
  //     startDate: exhibitDataForm.startDate,
  //     companyName: companyName,
  //     createdDate: currentDate,
  //     status: "Partner",
  //   };
  //   //this is where the form information will be taken and used to fill in the pdf form

  //   serviceProviderLessor.setText(exhibitDataForm.serviceProvider);
  //   commonName.setText(exhibitDataForm.commonName);
  //   address.setText(exhibitDataForm.locationAddress);
  //   city.setText(exhibitDataForm.city);
  //   state.setText(exhibitDataForm.state);
  //   zipCode.setText(exhibitDataForm.zipcode);
  //   sqftLeased.setText(exhibitDataForm.sqftLeased);
  //   description.setText(exhibitDataForm.description);
  //   startDate.setText(exhibitDataForm.startDate);
  //   expectedTerm.setText(exhibitDataForm.term);
  //   numberOfDesks.setText(exhibitDataForm.desks);
  //   companyNameForm.setText(companyName);

  //   switch (exhibitDataForm.propertyType) {
  //     case "Office":
  //       office.check();
  //       break;
  //     case "Industrial/Warehouse":
  //       industrial.check();
  //       break;
  //     case "Retail":
  //       retail.check();
  //       break;
  //     case "Mixed/Other":
  //       mixed.check();
  //       break;
  //     default:
  //       break;
  //   }

  //   switch (exhibitDataForm.spaceType) {
  //     case "Private office":
  //       privateOffice.check();
  //       break;
  //     case "cubicle":
  //       cubicle.check();
  //       break;
  //     default:
  //       break;
  //   }

  //   switch (exhibitDataForm.settingType) {
  //     case "Interior":
  //       interior.check();
  //       break;
  //     case "Window":
  //       exterior.check();
  //       break;
  //     default:
  //       break;
  //   }

  //   !!exhibitDataForm.facility &&
  //     exhibitDataForm.facility.forEach((item) => {
  //       switch (item) {
  //         case "cam":
  //           cam.check();
  //           break;
  //         case "furnished":
  //           furnishings.check();
  //           break;
  //         case "janitorial":
  //           janitorial.check();
  //           break;
  //         case "parking":
  //           parking.check();
  //           break;
  //         case "tax":
  //           insurace.check();
  //           break;
  //         default:
  //           break;
  //       }
  //     });

  //   !!exhibitDataForm.utility &&
  //     exhibitDataForm.utility.forEach((item) => {
  //       switch (item) {
  //         case "electricity":
  //           electirc.check();
  //           break;
  //         case "gas":
  //           gas.check();
  //           break;
  //         case "water":
  //           water.check();
  //           break;
  //         case "phone":
  //           phone.check();
  //           break;
  //         case "internet":
  //           internet.check();
  //           break;
  //         default:
  //           break;
  //       }
  //     });

  //   !!exhibitDataForm.amenity &&
  //     exhibitDataForm.amenity.forEach((item) => {
  //       switch (item) {
  //         case "meeting":
  //           conference.check();
  //           break;
  //         case "kitchen":
  //           kitchen.check();
  //           break;
  //         case "copy":
  //           copyFax.check();
  //           break;
  //         case "receptionist":
  //           receptionist.check();
  //           break;
  //         default:
  //           break;
  //       }
  //     });

  //   const pdfBytes = await pdfDoc.save();
  //   const newFile = new File([pdfBytes], "myTest.pdf", {
  //     type: "application/pdf",
  //   });

  //   // Create a reference for the PDF file in Firebase Storage
  //   const pdfRef = ref(
  //     storage,
  //     `${sluggedCompany}/pdfs/complyOfficeExhibit${timeStamp}`
  //   );

  //   // Upload the PDF
  //   const pdfUploadTask = uploadBytesResumable(pdfRef, newFile);

  //   // Handle PDF upload progress and completion
  //   pdfUploadTask.on(
  //     "state_changed",
  //     (snapshot) => {
  //       const progress = Math.round(
  //         (snapshot.bytesTransferred / snapshot.totalBytes) * 100
  //       );
  //       console.log(`PDF upload is ${progress}% done`);
  //     },
  //     (error) => {
  //       console.error("PDF upload error:", error);
  //     },
  //     async () => {
  //       console.log("PDF upload complete, fetching URL...");
  //       const pdfURL = await getDownloadURL(pdfUploadTask.snapshot.ref);
  //       console.log(`PDF is now available at ${pdfURL}`);

  //       exhibit.pdfURL = pdfURL; // Store the URL in your exhibit object

  //       // Prepare for other file uploads
  //       const promises = [];
  //       const uploadedUrls = []; // Array to hold the uploaded URLs

  //       fileUploads.forEach((file, index) => {
  //         const fileName = file.name || file.label || `file_${index}`;
  //         const storageRef = ref(
  //           storage,
  //           `/${sluggedCompany}/uploads/${fileName}`
  //         );

  //         // Create a resumable upload task for each file
  //         const uploadTask = uploadBytesResumable(storageRef, file);

  //         // Add progress listener
  //         uploadTask.on(
  //           "state_changed",
  //           (snapshot) => {
  //             const progress = Math.round(
  //               (snapshot.bytesTransferred / snapshot.totalBytes) * 100
  //             );
  //             console.log(`Upload #${index + 1} is ${progress}% done`);
  //           },
  //           (error) => {
  //             console.error(`Upload #${index + 1} error:`, error);
  //           },
  //           async () => {
  //             console.log(`Upload #${index + 1} is complete, fetching URL...`);
  //             const url = await getDownloadURL(uploadTask.snapshot.ref);
  //             console.log(`Upload #${index + 1} is now available at ${url}.`);
  //             uploadedUrls.push(url); // Add the URL to the array
  //           }
  //         );

  //         // Wait for the upload task to complete
  //         promises.push(uploadTask);
  //       });

  //       // Wait for all uploads to complete
  //       Promise.all(promises)
  //         .then(() => {
  //           // Ensure that fileUrls is updated correctly
  //           exhibit.fileUrls = uploadedUrls;

  //           // Now add the exhibit with the updated URLs
  //           addExhibit({ ...exhibit, fileUrls: exhibit.fileUrls });
  //         })
  //         .catch((err) => console.error("Error during file uploads:", err));
  //     }
  //   );
  // }

  return (
    <div>
      <Form
        isPartner={true}
        uploadImage={uploadImage}
        imageUpload={imageUpload}
        setImageUPload={setImageUPload}
        setFileUploads={setFileUploads}
        fileUploads={fileUploads}
        setFileUrls={setFileUrls}
        fileUrls={fileUrls}
        setExhibitData={setExhibitData}
        currentDate={currentDate}
        fillForm={fillForm}
        setReviewExhibitID={setReviewExhibitID}
      />
    </div>
  );
};

export default PartnerExhibit;
